/***
 * 将tree结构转换为数组
 */
export function getTreeExpandList(tree) {
  if (!tree) {
    return []
  }
  const list = []
  for (const item of tree) {
    list.push(item)
    if (item.children?.length > 0) {
      list.push(...getTreeExpandList(item.children))
    }
  }
  return list
}
